import React from 'react';
import {
  formatPurchaseMoney as money,
  formatPurchaseTime,
} from '../../utils/manualPurchase';

export const PurchaseError = ({ error }) =>
  error ? (
    <div
      role='alert'
      className='rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700 break-words'
    >
      <div className='flex items-center'>
        <svg
          aria-hidden='true'
          className='mr-2 h-5 w-5 shrink-0 text-red-400'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z'
          />
        </svg>
        <div className='min-w-0'>
          <p>{error.message || 'The request failed. Please try again.'}</p>
          {error.data?.traceId && (
            <p className='mt-2 text-xs'>
              Support reference: {error.data.traceId}
            </p>
          )}
        </div>
      </div>
    </div>
  ) : null;

const Row = ({ label, children }) => (
  <div className='flex flex-col justify-between gap-1 text-base sm:flex-row sm:gap-5'>
    <dt className='text-gray-500 shrink-0'>{label}</dt>
    <dd className='min-w-0 break-words text-left text-[#344154] sm:text-right'>
      {children || '—'}
    </dd>
  </div>
);

const PurchaseSummary = ({
  purchase,
  evidenceName,
  onViewEvidence,
  timeZone,
}) => (
  <dl className='space-y-[15px]'>
    <Row label='Creator'>{purchase.creator.name}</Row>
    <Row label='Reference'>{purchase.reference}</Row>
    <Row label='Payment date and time'>
      {formatPurchaseTime(purchase.paymentAt, timeZone)}
    </Row>
    <Row label='Payment evidence'>
      {purchase.evidenceId ? (
        onViewEvidence ? (
          <button
            type='button'
            className='text-blue-600 underline'
            onClick={onViewEvidence}
          >
            {evidenceName || 'View image'}
          </button>
        ) : (
          'Attached'
        )
      ) : (
        'No evidence'
      )}
    </Row>
    <div className='purchase-divider !mt-5 space-y-[15px] pt-5'>
      <Row label='Item'>{purchase.item.name}</Row>
      <Row label='Unit price x quantity'>
        {money(purchase.item.unitPrice)} x {purchase.quantity}
      </Row>
      <Row label='Subtotal'>{money(purchase.subtotal)}</Row>
      <Row label='Discount'>
        {purchase.discountType === 'none'
          ? 'None'
          : `${
              purchase.discountType === 'percentage'
                ? `${Number(purchase.discountValue)}% `
                : ''
            }(-${money(purchase.discountAmount)})`}
      </Row>
      <div className='flex justify-between gap-5 font-semibold text-[#344154]'>
        <dt className='text-gray-500'>Final total</dt>
        <dd className='text-xl leading-8'>{money(purchase.total)}</dd>
      </div>
    </div>
  </dl>
);

export default PurchaseSummary;
